import { createSelector } from "reselect";
import {
  fetchMappedKeyList,
  fetchSourceCollectorList,
  filterCustomDataDetails,
  getCustomDataObj,
  getEventAliasItems,
} from "./helper";

export const getCustomData = (state) => state.customdata;

export const getCustomDataList = createSelector([getCustomData], (customdata) =>
  customdata && customdata.list ? customdata.list : null,
);
export const getCustomDataAliasUnmapList = createSelector(
  [getCustomData],
  (customdata) =>
    customdata && customdata.aliasUnmapList ? customdata.aliasUnmapList : [],
);
export const getCustomDataListloaded = createSelector(
  [getCustomData],
  (customdata) => ({
    loading: customdata && customdata.isLoading ? customdata.isLoading : false,
    loaded: customdata && customdata.isLoaded ? customdata.isLoaded : false,
  }),
);
export const getCustomDataAliasListloaded = createSelector(
  [getCustomData],
  (customdata) => ({
    loading:
      customdata && customdata.isAliasListLoading
        ? customdata.isAliasListLoading
        : false,
    loaded:
      customdata && customdata.isAliasListLoaded
        ? customdata.isAliasListLoaded
        : false,
  }),
);
export const getACustomDataDetails = createSelector(
  [getCustomData],
  (customdata) =>
    filterCustomDataDetails(customdata && customdata.currentCustomData),
);
export const getACustomDataDetailsList = createSelector(
  [getCustomData],
  (customdata) => customdata && customdata.currentCustomDataList,
);
export const getACustomDataDetailsLoaded = createSelector(
  [getCustomData],
  (customdata) => ({
    currentCustomLoading:
      customdata && customdata.currentCustomLoading
        ? customdata.currentCustomLoading
        : false,
    currentCustomLoaded:
      customdata && customdata.currentCustomLoaded
        ? customdata.currentCustomLoaded
        : false,
  }),
);
export const getSourceCollectorList = createSelector(
  [getCustomData],
  (customdata) => {
    return customdata &&
      customdata.currentCustomData &&
      customdata.currentCustomData.sourceCollectors
      ? fetchSourceCollectorList(customdata.currentCustomData.sourceCollectors)
      : [];
  },
);
export const getMappedKeyList = createSelector(
  [getCustomData],
  (customdata) => {
    return customdata &&
      customdata.currentCustomData &&
      customdata.currentCustomData.mappedKeys
      ? fetchMappedKeyList(
          customdata.currentCustomData.mappedKeys,
          customdata?.currentCustomData?.type,
        )
      : [];
  },
);
export const successResponse = createSelector([getCustomData], (customdata) => {
  return customdata && customdata.successResponse
    ? customdata.successResponse
    : undefined;
});
export const errorResponse = createSelector([getCustomData], (customdata) => {
  return customdata && customdata.error ? customdata.error : undefined;
});
export const removeSuccessResponse = createSelector(
  [getCustomData],
  (customdata) => {
    return customdata && customdata.removeSuccessResponse
      ? customdata.removeSuccessResponse
      : undefined;
  },
);
export const getAliasLogs = createSelector(
  [getCustomData],
  (customData) => customData?.aliasLogs && customData?.aliasLogs?.data,
);

export const getAliasLogsLoadingStatus = createSelector(
  [getCustomData],
  (customData) => ({
    loading: customData?.aliasLogLoading,
    loaded: customData?.aliasLogLoaded,
  }),
);

export const getEventListAlias = createSelector(
  [getCustomData],
  (customData) => ({
    customEventList: getEventAliasItems(customData?.customEventList?.events),
  }),
);

export const getCustomDataTotal = createSelector(
  [getCustomData],
  (customdata) => (customdata && customdata.total ? customdata.total : null),
);

export const getCustomDataListTypesLoading = createSelector(
  [getCustomData],
  (customdata) => ({
    loading: customdata && customdata.loading ? customdata.loading : false,
    loaded: customdata && customdata.loaded ? customdata.loaded : false,
  }),
);
export const getCustomDataCheckCount = createSelector(
  [getCustomData],
  (customdata) =>
    customdata?.checkCountResponse ? customdata.checkCountResponse : null,
);
